import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { ISkillListItemFragment } from 'graphql/types';
import { isSkillSelected } from 'skill/utils/skillSelect';

import { SkillSelectorListItem } from './SkillSelectorListItem';

interface IProps {
    addedSkills: ISkillListItemFragment[];
    selectedSkills: ISkillListItemFragment[];
    skills: ISkillListItemFragment[];
    onAddSkill?(selectedSkill: ISkillListItemFragment): void;
    onRemoveSkill?(selectedSkill: ISkillListItemFragment): void;
}

export const SkillAddList = ({
    addedSkills,
    selectedSkills,
    skills,
    onAddSkill,
    onRemoveSkill,
}: IProps) => {
    const [translate] = useTranslation();

    return (
        <>
            {!skills.length ? (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: 7,
                    }}
                >
                    <Typography>{translate('noOptionsText.skills')}</Typography>
                </Box>
            ) : (
                skills.filter(Boolean).map((skill) => {
                    const isSelected = isSkillSelected(selectedSkills, skill);
                    const isAdded = isSkillSelected(addedSkills, skill);

                    return (
                        <SkillSelectorListItem
                            addButton
                            added={isAdded}
                            key={skill.id}
                            px={2}
                            selected={isSelected}
                            skill={skill}
                            onClick={() =>
                                isSelected
                                    ? onRemoveSkill?.(skill)
                                    : onAddSkill?.(skill)
                            }
                        />
                    );
                })
            )}
        </>
    );
};
